import { createDefaultAddressData, IAddressData } from '../../ui-toolkit/orders/interfaces/IAddressResponse';
import { eTitleSearchStatus } from '../order/title/eTitleSearchStatus';
import { eTransactionCategory } from '../../ui-toolkit/enums/eTransactionType';

export interface IVendorOrderInformationRequest {
  titleSearchId: string;
  orderId: string;
  fileNumber: string;
  transactionCategory: eTransactionCategory;
  address: IAddressData;
  borrowers: string;
  sellers: string;
  status: eTitleSearchStatus;
  timeEnteredQueue: string;
  titleCommitmentFinalizedAt?: string;
  lenderCompanyName: string;
  clientCompanyName: string;
  titleCommitmentId?: string;
  taxCertificationRequestId?: string;
}

export interface IVendorOrderInformationData extends IVendorOrderInformationRequest {
  address: IAddressData;
}

export const createDefaultVendorOrderInformationData = (): IVendorOrderInformationData => ({
  titleSearchId: '',
  orderId: '',
  fileNumber: '',
  transactionCategory: eTransactionCategory.Refinance,
  lenderCompanyName: '',
  clientCompanyName: '',
  address: createDefaultAddressData(),
  borrowers: '',
  sellers: '',
  timeEnteredQueue: '',
  status: eTitleSearchStatus.new,
  taxCertificationRequestId: undefined,
});

export const convertFromVendorOrderInformationRequestToVendorOrderInformationData = (
  data: IVendorOrderInformationRequest
): IVendorOrderInformationData => data;
